import { Injectable } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { FrontEndService } from "app/services/front-end.service";
import { LogService } from "app/services/log.service";
import { HttpClient } from "@angular/common/http";
import { StateService } from '@uirouter/angular';
import { ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Injectable()
export class DataService {

    userRoles: Array<Select2OptionData>;
    userRolesOptions: any;
    feedBackProjectStatus: Array<Select2OptionData>;
    feedBackProjectStatusOptions: any;
    currentUser = {};
    isLoggedIn = false;
    langPreference = {};
    titles: Array<Select2OptionData>;
    x_y_a: Array<Select2OptionData>;
    project_status: Array<Select2OptionData>;
    project_search_status: Array<Select2OptionData>;
    titleOptions: any;
    x_y_aOptions: any;
    projectStatusOptions: any;
    patent_engineer: any;
    patent_engineer_options: any;
    technical_expert_options: any;
    researcher_options: any;
    reviewer_options: any;
    prior_art_cut_off_date_options: any;

    project_get_waiting_for_response = false;
    project_list = [];
    projectListObservable: Subject<any> = new Subject<any>();
    selected_project = 0;
    current_project_changed = false;

    wall_get_waiting_for_response = false;
    wall_list = [];
    wall_count = 10;
    wall_limit = 10;

    files_waiting_for_response = false;
    wall_files_list = [];
    wall_files_count = 10000;
    wall_files_limit = 10;

    activity_waiting_for_response = false;
    activity_list = [];
    activity_count = 10;
    activity_limit = 10;
    unreadNotification = 0;

    for_all_activity = true;

    subDomain:any;

    enJson = true;
    isConnected = true;
    workspaceEnabled = false;
    projectModuleEnabled = false;
    userProfileModuleEnabled = false;
    evaluationModuleEnabled = false;
    chatModuleEnabled = false;

    projectTypeOptions = {
        placeholder: 'Select Project Type'
    };

    projectTypes = [
        {
            id: '0',
            text: "(In)Validity Search"
        },
        {
            id: '1',
            text: "Novelty Search"
        },
        {
            id: '2',
            text: "Evidence of Use"
        },
        {
            id: '3',
            text: "Patent Evaluation"
        },
        {
            id: '4',
            text: "Landscape"
        },
        {
            id: '5',
            text: "Freedom to Operate Search"
        },
        {
            id: '6',
            text: "State-of-the-Art Search"
        },
        {
            id: '7',
            text: "Search-Accelerated Examination"
        }
    ];

    static getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    constructor(
        private front_end_service: FrontEndService,
        private http: HttpClient,
        private stateService: StateService,
        private logService: LogService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUserProfile'));
        this.isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn'));

        this.userRoles = [
            {
                id: '0',
                text: 'Super Admin'
            },
            {
                id: '1',
                text: 'Admin'
            },
            {
                id: '2',
                text: 'Researcher'
            },
            {
                id: '3',
                text: 'IPR/Technical Engineer/Legal Counsel'
            },
            {
                id: '4',
                text: 'Customer Admin'
            }
        ];

        this.userRolesOptions = {
            placeholder: 'Please select role'
        };

        this.feedBackProjectStatus = [
            {
                id: '0',
                text: 'Open'
            },
            {
                id: '1',
                text: 'In Progress'
            },
            {
                id: '2',
                text: 'Resolved'
            },
            {
                id: '3',
                text: 'Un Resolved'
            }
        ];

        this.feedBackProjectStatusOptions = {
            placeholder: 'Please select Project Status'
        };

        this.x_y_a = [
            {
                id: 'null',
                text: 'Please select x y a'
            },
            {
                id: 'x',
                text: 'X'
            },
            {
                id: 'y',
                text: 'Y'
            },
            {
                id: 'a',
                text: 'A'
            }
        ];

        this.x_y_aOptions = {
            placeholder: 'Please select x y a'
        };

        this.titles = [
            {
                id: 'null',
                text: 'Please select title'
            },
            {
                id: 'Mr.',
                text: 'Mr.'
            },
            {
                id: 'Ms.',
                text: 'Ms.'
            },
            {
                id: 'Mrs.',
                text: 'Mrs.'
            }
        ];

        this.titleOptions = {
            placeholder: 'Please select title'
        };

        this.project_search_status = [
            {
                id: 'IP',
                text: 'IP-in Progress'
            },
            {
                id: 'All',
                text: 'All'
            },
            {
                id: 'CO',
                text: 'CO-Closed'
            },
            {
                id: 'OH',
                text: 'OH-On Hold'
            },
            {
                id: 'Archived',
                text: 'Archived'
            },

        ];

        this.project_status = [

            {
                id: 'CO',
                text: 'CO-Closed'
            },
            {
                id: 'IP',
                text: 'IP-in Progress'
            },
            {
                id: 'OH',
                text: 'OH-On Hold'
            }
        ];

        this.projectStatusOptions = {
            placeholder: 'Select Project Status'
        };
        this.patent_engineer_options = {
            placeholder: 'Please select patent engineer',
            multiple: true
        };
        this.technical_expert_options = {
            placeholder: 'Please select technical expert',
            multiple: true
        };
        this.prior_art_cut_off_date_options = {
            placeholder: 'Please select prior cutoff date',
            multiple: true
        };
        this.researcher_options = {
            placeholder: 'Please select researcher',
            multiple: true
        };
        this.reviewer_options = {
            placeholder: 'Please select reviewer',
            multiple: true
        };

        this.getSubDomain();
    }

    fileTypeIcons(type) {
        // configure your icon file extensions
        let html: string;

        switch(type) {
            case '.doc': html = '<i class="fa fa-file-word-o text-primary"></i>'; break;
            case '.docx': html = '<i class="fa fa-file-word-o text-primary"></i>'; break;
            case '.csv': html = '<i class="fa fa-file-excel-o text-success"></i>'; break;
            case '.xls': html = '<i class="fa fa-file-excel-o text-success"></i>'; break;
            case '.xlsx': html = '<i class="fa fa-file-excel-o text-success"></i>'; break;
            case '.ppt': html = '<i class="fa fa-file-powerpoint-o text-danger"></i>'; break;
            case '.pptx': html = '<i class="fa fa-file-powerpoint-o text-danger"></i>'; break;
            case '.pdf': html = '<i class="fa fa-file-pdf-o text-danger"></i>'; break;
            case '.zip': html = '<i class="fa fa-file-archive-o text-muted"></i>'; break;
            case '.rar': html = '<i class="fa fa-file-archive-o text-muted"></i>'; break;
            case '.tar': html = '<i class="fa fa-file-archive-o text-muted"></i>'; break;
            case '.gzip': html = '<i class="fa fa-file-archive-o text-muted"></i>'; break;
            case '.gz': html = '<i class="fa fa-file-archive-o text-muted"></i>'; break;
            case '.7z': html = '<i class="fa fa-file-archive-o text-muted"></i>'; break;
            case '.htm': html = '<i class="fa fa-file-code-o text-info"></i>'; break;
            case '.html': html = '<i class="fa fa-file-code-o text-info"></i>'; break;
            case '.txt': html = '<i class="fa fa-file-text-o text-info"></i>'; break;
            case '.log': html = '<i class="fa fa-file-text-o text-info"></i>'; break;
            case '.mov': html = '<i class="fa fa-file-movie-o text-warning"></i>'; break;
            case '.mp3': html = '<i class="fa fa-file-audio-o text-warning"></i>'; break;
            case '.wav': html = '<i class="fa fa-file-audio-o text-warning"></i>'; break;
            case '.jpg': html = '<i class="fa fa-file-photo-o text-danger"></i>'; break;
            case '.jpeg': html = '<i class="fa fa-file-photo-o text-danger"></i>'; break;
            case '.gif': html = '<i class="fa fa-file-photo-o text-muted"></i>'; break;
            case '.png': html = '<i class="fa fa-file-photo-o text-primary"></i>'; break;
            default: html = '<i class="fa fa-file-o text-primary"></i>'; break;
        }
        return html;
    }

    setCurrentUserDetails(data) {
        this.currentUser = data;
        data['role'] = parseInt(data['role'], 10);
        localStorage.setItem('currentUserProfile', JSON.stringify(data));
    }

    get_array_details(set_array, key, id) {
        /**
         * get project from ID
         */
        return set_array.find(x => x[key] === id);
    }

    sort_this(sort_array, sort_by) {
        return sort_array.sort(
            (a, b) => a[sort_by] > b[sort_by] ? -1 : a[sort_by] < b[sort_by] ? 1 : 0
        );
    }

    sort_this_by_date(sort_array, sort_by) {
        return sort_array.sort(
            (a, b) => new Date(a[sort_by]).getTime() < new Date(b[sort_by]).getTime() ? -1 : new Date(a[sort_by]).getTime() > new Date(b[sort_by]).getTime() ? 1 : 0
        );
    }

    getFormattedDate(oldDate) {
        return oldDate.format("MMM DD, YYYY");
    }

    filter_on_role_type(oldArray, filterBy) {
        const newArray = [];
        for(let i=0;i<oldArray.length;i++) {
            if(oldArray[i].role === filterBy) {
                newArray.push(oldArray[i]);
            }
        }
        return newArray;
    }

    getSubDomain() {
        const host = window.location.host;
        const hostArr = host.split('.');
        if(hostArr.length > 2) {
            this.subDomain = hostArr[0];
        } else {
            this.subDomain = host;
        }
    }

    getProjectType(id) {
        let selectedProjectType = "";
        this.projectTypes.forEach((projectType) => {
            if (projectType.id === id) {
                selectedProjectType = projectType.text;
            }
        });
        return selectedProjectType;
    }

    getFieldNamesBasedOnProjectType(projectType: string): {} {
        const fieldNames = {};
        switch(parseInt(projectType, 10)) {
            case 0:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['patent_number'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['claims_to_be_searched'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['select_prior_cut_off_date'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['prior_art_cut_off_date'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['known_prior_art'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['other_information'];
                break;
            case 1:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['invention_title'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['invention_description_search_focus'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['select_prior_cut_off_date'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['prior_art_cut_off_date'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['known_prior_art'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['other_information'];
                break;
            case 2:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['patent_number'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['claims_to_be_searched'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['select_prior_cut_off_date'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['prior_art_cut_off_date'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['type_of_claims'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['targets_company_products'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['jurisdictions'];
                break;
            case 3:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['patent_publication_portfolio'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['objective'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['date_restriction'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['date_restriction'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['targets_company_products'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['jurisdictions'];
                break;
            case 4:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['title'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['objective'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['date_restriction'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['date_restriction'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['jurisdictions'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['other_information'];
                break;
            case 5:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['title'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['product_features'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['date_restriction'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['date_restriction'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information_with_details'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['known_prior_art'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['jurisdictions'];
                break;
            case 6:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['invention_title'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['invention_description_search_focus'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['select_prior_cut_off_date'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['prior_art_cut_off_date'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['known_prior_art'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['other_information'];
                break;
            case 7:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['application_number'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['drafted_claims_drafted_application'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['select_prior_cut_off_date'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['prior_art_cut_off_date'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['known_prior_art'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['database_preferences'];
                break;
            default:
                fieldNames['patent_number'] = this.front_end_service.en_json_data['patent_number'] + " (*)";
                fieldNames['claims_to_be_searched'] = this.front_end_service.en_json_data['claims_to_be_searched'] + " (*)";
                fieldNames['select_prior_cut_off_date'] = this.front_end_service.en_json_data['select_prior_cut_off_date'];
                fieldNames['prior_art_cut_off_date'] = this.front_end_service.en_json_data['prior_art_cut_off_date'];
                fieldNames['technical_field'] = this.front_end_service.en_json_data['technical_field'];
                fieldNames['useful_information'] = this.front_end_service.en_json_data['useful_information'];
                fieldNames['known_prior_art'] = this.front_end_service.en_json_data['known_prior_art'];
                fieldNames['other_information'] = this.front_end_service.en_json_data['other_information'];
        }
        return fieldNames;
    }

    /**
     * Escape characters to match regular expression
     * @param string
     */
    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    /**
     * Get permissions for a module from the config file
     * @param callBack
     */
    getModulePermissions(callBack) {
        let host = "dev";
        if (window['_env'].production) {
            host = window.location.host.split('.')[0];
        }
        this.http.get(`assets/module_conf/${host}_conf.json`).subscribe(
            response => {
                this.projectModuleEnabled = response["projectModuleEnabled"];
                this.userProfileModuleEnabled = response["userProfileModuleEnabled"];
                this.workspaceEnabled = response["workspaceEnabled"];
                if (response.hasOwnProperty('evaluationModuleEnabled')) {
                    this.evaluationModuleEnabled = response["evaluationModuleEnabled"];
                }
                if (response.hasOwnProperty('chatModuleEnabled')) {
                    this.chatModuleEnabled = response['chatModuleEnabled'];
                }
                callBack();
            },
            error => {
                this.stateService.go("Forbidden");
            }
        );
    }

    /**
     * Removes all illegal characters
     * @param str - String to be sanitized
     */
    sanitizeString(str) {
        str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
        return str.trim();
    }

    /**
     * Escape illegal characters
     * @param str - String to be sanitized
     */
    escapeUnicode(str) {
        // ILLEGAL_CHARACTERS_REGEX = '[\000-\010]|[\013-\014]|[\016-\037]';
        return str.replace(/[^\0-~]/g, function(ch) {
            return "\\u" + ("000" + ch.charCodeAt().toString(16)).slice(-4);
        });
    }

    /**
     * Add p tags around text if not there
     * @param text
     */
    addDivTag(text) {
        if (!text.startsWith("<div>")) {
            text = `<div>${text}`;
        }
        if (!text.endsWith("</div>")) {
            text = `${text}</div>`;
        }
        return text;
    }

    /**
     * Remove html tags for text area
     * @param val
     */
    getInnerHTML(val) {
        return val.replace(/(<([^>]+)>)/ig,'');
    }

    /**
     * Swap items within an array
     * @param arr
     * @param indexA
     * @param indexB
     */
    swapArrayElements(arr, indexA, indexB) {
        const temp = arr[indexA];
        arr[indexA] = arr[indexB];
        arr[indexB] = temp;
    }

    /**
     * Drag element from one index to another
     * @param arr
     * @param from
     * @param to
     */
    dragArrayElement(arr, from, to) {
        const column = arr[from];
        arr.splice(from, 1);
        arr.splice(to, 0, column);
        return arr;
    }
}
